import React, { useState } from "react";
import { Download, Loader2 } from "lucide-react";
import api from "@/lib/api";

export const ExportUsersButton = () => {
  const [busy, setBusy] = useState(false);
  const [err, setErr] = useState("");

  const download = async () => {
    setBusy(true); setErr("");
    try {
      const res = await api.get("/admin/export/users-drops.xlsx", { responseType: "blob" });
      const cd = res.headers["content-disposition"] || "";
      const name = (cd.match(/filename="([^"]+)"/) || [])[1] || "LT_Users_CardDrops.xlsx";
      const url = URL.createObjectURL(res.data);
      const a = document.createElement("a");
      a.href = url; a.download = name; document.body.appendChild(a); a.click(); a.remove();
      URL.revokeObjectURL(url);
    } catch (e) {
      setErr("Download failed. Please try again.");
    } finally { setBusy(false); }
  };

  return (
    <div className="flex items-center gap-3 mb-4">
      <button onClick={download} disabled={busy} data-testid="admin-export-users-xlsx-btn"
        className="lt-btn-primary px-4 py-2 text-sm rounded flex items-center gap-2 disabled:opacity-60">
        {busy ? <Loader2 className="w-4 h-4 animate-spin" /> : <Download className="w-4 h-4" />}
        {busy ? "Preparing Excel…" : "Download Users + Card Drops (Excel)"}
      </button>
      {err && <span className="text-sm text-red-400" data-testid="admin-export-users-error">{err}</span>}
    </div>
  );
};
